import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-order-status",
  templateUrl: "./order-status.component.html",
  styleUrls: ["./order-status.component.scss"],
})
export class OrderStatusComponent implements OnInit, OnDestroy {
  cssClass = {};
  _status: any;
  private destroy$ = new Subject<void>();

  @Input() set status(value) {
    if (value) {
      this.cssClass["status--" + value.toLowerCase()] = true;
      this._status = value;
    }
  }
  get status() {
    return this._status;
  }
  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
